import Baloon from '../Baloon';

class Donut extends Baloon {
  constructor(THREE) {
    super(THREE);
    this.id = 'donut';
  }
}

export default Donut;
